import { url } from "./MongoConstants";

const getBetSummary = async () => {
    try {
        const server = url;
        const response = await fetch(server + '/api/data/bet/summary', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            const data = await response.json();
            return(data)
        } else {
            console.log('Failed to get bet summary');
            return('Failed to get bet summary');
        }
    } catch (error) {
        console.error('An error occurred:', error);
        return('An error occurred:', error);
    }
};

export default getBetSummary;